import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';
import FormStyles from 'styles/mixins/Form.styles';

const StyledFilterSelectionDialog = styled(Dialog)`
  .MuiDialog-paper {
    min-width: clamp(0px, ${props => props.theme.layout(884)}, 86vw);
    max-width: clamp(0px, ${props => props.theme.layout(884)}, 86vw);
  }

  .FilterSelectionDialog {
    &-info {
      margin-bottom: ${props => props.theme.spacing(2)};
    }
  }
  
  ${FormStyles}
  ${ComponentStyles}
`;

StyledFilterSelectionDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledFilterSelectionDialog;
